import React from "react"
import SideNav from "components/SideNav"
import {
  getCategories,
  selectCategoriesAsArray,
  destroyCategory,
} from "data/categories"
import { categoryEditPath } from "utils/paths"
import { connect } from "react-redux"
import Table from "components/Table"
import styles from "./styles.scss"
import { Link } from "react-router-dom"
import AdminHeader from "../../components/AdminHeader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class CategoryIndex extends React.Component {
  componentDidMount() {
    this.props.getCategories()
  }

  onDelete = id => {
    window.confirm('Är du säker att du vill ta bort kategorin?') &&
    this.props.destroyCategory(id)
  }

  render() {
    const { categories } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <AdminHeader />
          <div className={styles.categoryTableWrapper}>
            <SideNav type="categories" />
            <div className={styles.categoryTable}>
              <Table title={"Kategorier"} >
                <thead>
                  <tr>
                    <th>Namn</th>
                    <th />
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {categories.map(category => (
                    <tr className={styles.everyTwo} key={category.id}>
                      <td>{category.name}</td>
                      <td>
                        <Link to={categoryEditPath(category.id)}>
                          <FontAwesomeIcon icon="pencil-alt" />
                        </Link>
                      </td>
                      <td
                        className={styles.deleteField}
                        onClick={() => 
                          this.onDelete(category.id)
                        }
                      >
                        <FontAwesomeIcon icon="trash-alt" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  categories: selectCategoriesAsArray(state, ownProps),
})

export default connect(
  mapStateToProps,
  {
    getCategories,
    destroyCategory,
  }
)(CategoryIndex)



// WEBPACK FOOTER //
// src/pages/Admin/Categories/CategoryIndex/index.jsx